var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"swiper",rawName:"v-swiper:NewsSlider",value:(_vm.settings),expression:"settings",arg:"NewsSlider"}]},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"relative text-center lg:hidden top-0 news-pagination swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }